import { useQuery } from 'react-query';
import axios from 'axios';
import useRingSettings from './useRingSettings';

const fetchS3File = async (url: string) => {
    if (!url) {
        return;
    }
    const { data } = await axios({
        url: `https://${url}`,
        method: 'GET',
        headers: {
            'content-type': 'text/javascript',
        },
    });
    return data;
};

const useLoadCustomizationScripts = (eventId: number, accountId: number) => {
    const ringSettings = useRingSettings(eventId, accountId, {
        enabled: !!(eventId && accountId),
        retry: 1,
    });
    const { customization } = ringSettings.data ?? {};
    const cssContentQuery = useQuery(
        ['cssContent', customization],
        () => fetchS3File(customization?.customCssFile),
        {
            enabled: customization?.enableCssInject && !!customization?.customCssFile,
            staleTime: Infinity,
        }
    );
    const jsHeadContentQuery = useQuery(
        ['jsHeadContent', customization],
        () => fetchS3File(customization?.customJsHeadFile),
        {
            enabled: customization?.enableJsInject && !!customization?.customJsHeadFile,
            staleTime: Infinity,
        }
    );
    const jsBodyContentQuery = useQuery(
        ['jsBodyContent', customization],
        () => fetchS3File(customization?.customJsBodyFile),
        {
            enabled: customization?.enableJsInject && !!customization?.customJsBodyFile,
            staleTime: Infinity,
        }
    );
    return {
        cssContent: cssContentQuery,
        jsHeadContent: jsHeadContentQuery,
        jsBodyContent: jsBodyContentQuery,
    };
};

export default useLoadCustomizationScripts;
